import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { SearchbarModule } from '../core/searchbar/searchbar.module';
import { InViewportModule } from '@thisissoon/angular-inviewport';
import { SharedPipesModule } from '../core/pipes/shared-pipes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResultsRoutingModule } from './results-routing.module';
import { MapComponent } from './map/map.component';
import { DialogsModule } from '../core/dialogs/dialogs.module';
import { DisclaimerModule } from '../core/disclaimer/disclaimer.module';

@NgModule({
  declarations: [MapComponent],
  imports: [
    InViewportModule,
    SearchbarModule,
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatMenuModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    AgmCoreModule,
    AgmSnazzyInfoWindowModule,
    SharedPipesModule,
    DialogsModule,
    ResultsRoutingModule,
    DisclaimerModule
  ]
})
export class ResultsModule {}
